import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';
import Button from '@kyruus/button';
import { MiniProviderCardList } from '@kyruus/provider-components';
import { BREAKPOINTS } from '../../lib/constants';

export const CareTeamHeader = styled.div`
  color: ${fromTheme('color_text')};
  margin-bottom: ${fromTheme('spacing_medium')};
`;

export const CareTeamTitle = styled.h2`
  font-size: ${fromTheme('font_size_heading_4')};
  font-weight: ${fromTheme('font_weight_bolder')};
  margin: 0;
`;

export const CareTeamSubtitle = styled.p`
  font-size: ${fromTheme('font_size')};
  font-weight: ${fromTheme('font_weight')};
  margin: ${fromTheme('spacing_xsmall')} 0 0 0;
`;

// Should match AltProvidersList styles for now
export const CareTeamProviderList = styled(MiniProviderCardList)`
  > div {
    width: 100%;
    @media screen and (min-width: ${BREAKPOINTS.small}px) {
      width: calc(50% - 8px);
    }
  }
`;

export const CareTeamExpandedProviderList = styled(CareTeamProviderList)`
  margin-top: ${fromTheme('spacing_medium')};
`;

export const ShowMoreButton = styled(Button)`
  margin-top: ${fromTheme('spacing_medium')};
`;
